import React from 'react';

import {checkHexFormat, blendColors} from '../../components/UniversalMethods';

import {AddButton} from '../../components/Button/Button';
import Palette from '../../components/Palette/Palette';

import './Pallettes.css';

class Pallettes extends React.Component {


    state = {
        colors: [],
        transition: {
            state: false,
            color: ''
        }
    }

    componentDidMount = () => {
        this.updatePalette();
    }
    componentDidUpdate = (prevProps) => {
        if(this.props !== prevProps) this.updatePalette();
    }
    updatePalette = () => {
        const query = new URLSearchParams(this.props.history.location.search);
        const colors = query.get('colors') !== null ? query.get('colors').split(',') : [];
    
        // check if the params do not exist or they are not proper hex values
        if(colors.length === 0 || colors.filter(hex => checkHexFormat(hex)).length !== colors.length ){
            const newColors = generatePalette();
            this.props.history.push({
                pathname: this.props.match.path,
                search: '?colors=' + newColors.join()
            })
        }else{
            this.setState({
                colors: colors
            })
        }
    }

    editColor = (color) => {
        this.setState({
            transition: {
                state: true,
                color: color
            }
        })

        this.timer = setTimeout(() => {
            this.props.history.push("../hex/" + color);
            clearTimeout(this.timer);
        }, 200);
    }

    addColor = (index) => {
        const colorA = '#' + this.state.colors[index];
        const colorB = '#' + this.state.colors[index+1];
        const newColor = blendColors(colorA, colorB).replace('#', '');
        let newColors = [...this.state.colors];
        newColors.insert(index+1, newColor);

        this.props.history.push({
            pathname: this.props.match.path,
            search: '?colors=' + newColors.join()
        });
    }
    
    removeColor = (color) => {
        this.props.history.push({
            pathname: this.props.match.path,
            search: '?colors=' + this.state.colors.filter(c => c !== color).join()
        })
    }

    renderPallete = () => {
        const perc = 1/this.state.colors.length*100;
        return this.state.colors.map((color, index) => {
            const width = this.state.transition.state ? this.state.transition.color === color ? '100%' : '100%' : perc+'%';
            const left = this.state.transition.state ? this.state.transition.color === color ? '0%' : index*perc+'%' : index*perc+'%';
            const zIndex = this.state.transition.state ? this.state.transition.color === color ? '100' : '1' : '1';
            const addButtonX = (index*perc + perc)+'%';
            
            const rtnObj = [];
            rtnObj.push(<Palette key={`color-${color}`} className={index} style={{color:color, width: width, left: left, zIndex: zIndex}} transition={{state: this.state.transition.state, color: this.state.transition.color}} editColor={this.editColor} removeColor={this.removeColor}/>);
            if(index < this.state.colors.length - 1 && this.state.colors.length < 10) rtnObj.push(<AddButton callback={() => this.addColor(index)} style={{left: addButtonX, zIndex: '100'}}/>);
            return rtnObj
        })
    }

    render(){
        return <div className='Pallettes'>
                <div className='color-palette'>{this.renderPallete()}</div>
        </div>
    }
}

export default Pallettes;


const generatePalette = () => {
    return ['0081AF', '00ABE7', '2DC7FF', 'EAD2AC', 'EABA6B']
}